<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    opacity="0.2"
    d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C7.44477 19 5.13825 17.9351 3.5 16.225C1.95145 14.6084 1 12.4153 1 10ZM10 3C6.13401 3 3 6.13401 3 10C3 11.8786 3.74002 13.5843 4.94444 14.8416L10 10V17C13.866 17 17 13.866 17 10H10V3Z"
    fill="currentColor"
  />
</svg>
